import React from 'react';
import { Tag } from 'antd';
import { statusColors, statusTexts } from './tokens';

interface StatusBadgeProps {
  status: string | boolean;
  type?: 'order' | 'user';
  customText?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  type = 'user',
  customText,
}) => {
  const statusKey = typeof status === 'boolean' ? String(status) : status;
  const color = statusColors[statusKey] || 'default';

  let text = customText;
  if (!text) {
    if (type === 'order' && statusTexts.order[statusKey]) {
      text = statusTexts.order[statusKey];
    } else if (type === 'user') {
      if (typeof status === 'boolean') {
        text = status ? statusTexts.user.active : statusTexts.user.inactive;
      } else {
        text = statusTexts.user[statusKey] || statusKey;
      }
    } else {
      text = statusKey;
    }
  }

  // Ensure sufficient contrast for accessibility
  const style: React.CSSProperties = {
    fontWeight: 500,
    fontSize: '12px',
    padding: '2px 8px',
    borderRadius: '4px',
    border: 'none',
  };

  return (
    <Tag color={color} style={style} aria-label={`Trạng thái: ${text}`}>
      {text}
    </Tag>
  );
};
